import type { FaireProductEntity } from "../../entity_types/product";

export const p_hxbef8kp2q: FaireProductEntity = {
  token: "p_hxbef8kp2q",
  type: "product",
  name: "Creative Octopus Jellyfish Pendant Necklace_CWMM5311",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/b48be31304929132c18b2521dfe44a94f9c188cbd47160e1c6ad44a509b56743.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6218461785f46b36a385478b1c963a127eb721956af6388f9e1c74b19d26e052.jpeg",
    "https://cdn.faire.com/fastly/4a437af8cdfdad96c7ef633e4dc4ee5586eae9439f4e5e5b8fbb42a95b75156b.jpeg",
    "https://cdn.faire.com/fastly/686720a733a3800f0c4fcda025ef31056f6acf36bdf684179c98456e511bc2c4.jpeg",
    "https://cdn.faire.com/fastly/17845bec05d3d64e2ed8095a03a88a43c342bbb86b635717f15e440bbfb32378.jpeg",
  ],
  priceDollars: 13.16,
  description:
    "SIZE:OS (1)\n100% COPPER\n MADE IN CHINA\n\nNecklaces,Necklaces For Women,Necklace Display,Necklace Charms,Necklace Displays For Retail,Necklaces Trending,Necklace Display Stand For Retail,Necklace Chain,Necklaces For Women Gold,Necklace Stand,Pendant Necklace,Pendant Necklace For Women,Pendant Necklaces For Women,Pendant Necklace For Boyfriend,Pendant Necklace For Couples,Pendant Necklace Gold,Pendant Necklaces,Pendant Necklace Diamond,Pendant Necklace For Fathers Day,Pendant Necklace Initial,Christmas Necklaces For Women,Christmas Necklaces,Light Up Christmas Necklace,Girls Christmas Necklace,Womens Christmas Necklace,Halloween Necklaces,Light Up Halloween Necklace,Alphabet Pendant Necklace,Vintage Necklace Display,Long Vintage Necklaces,Bohemian Vintage Necklace,Gemstone Vintage Necklace,Beaded Necklaces For Women,Beaded Necklaces For Boho Style,Beaded Necklace With Pendant,Pendant/Charm Necklace,Link &amp; Chain Necklace,Aromatherapy Necklace",
  tags: [],
  msrpDollars: 26.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:45.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
